import { ContactCard } from "./ContactCard";

export function ContatoSection() {
  return (
    <div
      id="contato"
      className="page-section flex flex-col flex-grow bg-petroleo"
    >
      <section className="bg-petroleo text-white relative pt-nav pb-24 flex-grow">
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 w-full max-w-7xl h-1 bg-gradient-to-r from-transparent via-dourado to-transparent opacity-30"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10 mt-10">
          <i className="fa-solid fa-compass-drafting text-6xl text-dourado mb-6"></i>
          <h2 className="text-4xl sm:text-5xl font-titulo font-bold mb-6">
            Venha Conhecer-nos
          </h2>
          <p className="text-lg sm:text-xl text-gray-300 max-w-3xl mx-auto mb-16 font-light">
            Nossos trabalhos ocorrem ritualisticamente às{" "}
            <strong className="text-white">
              primeiras e terceiras terças-feiras
            </strong>{" "}
            de cada mês, às 20h. Irmãos regulares de todos os orientes são
            fraternos e bem-vindos.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto text-left">
            {/* Card Templo */}
            <ContactCard icon="fa-location-dot" title="Localização do Templo">
              <p className="text-gray-300 leading-relaxed text-base sm:text-lg">
                Rua Marechal Rondon, nº 48, Barreiros <br />
                São José / SC - CEP: 88117-130
              </p>
            </ContactCard>

            {/* Card Mensagem */}
            <ContactCard icon="fa-envelope" title="Comunicação Digital">
              <p className="text-gray-300 leading-relaxed text-base sm:text-lg mb-6">
                Para contactos oficiais, solicitações de visitação ou ações de
                solidariedade.
              </p>
              <a
                href="mailto:lj147@mrglsc.org.br"
                className="text-xl sm:text-2xl text-dourado hover:text-white transition font-bold mb-8 break-words"
              >
                lj147@mrglsc.org.br
              </a>
            </ContactCard>
          </div>
        </div>
      </section>
    </div>
  );
}
export default ContatoSection;
